
import commonApi from "@/apis/common.api";
import realtimeApi from "@/apis/realtime.api";
import { $_DKD, $_WC, $_ADM, $_CD } from "@/confs/common.const.js";
import {$_TYPE} from "../confs/common.const";
import gripUtil from "@/libs/grip.util";
import { local } from "d3v4";

export default {
    state: {
        safetyList: [],
        safetyTodayList: [],
        accidentList: [],
        waterQualityList: [],
        waterLevelList: [],
        uticCctvList: [],
        accidentTypeCodeMap: {'1': '사고', '2': '공사', '3': '행사', '4': '기상', '5': '통제'},
        waterHjdMeta: {
            val6: {name: '전기전도도', unit: 'µs/cm',},
            val7: {name: 'PH', unit: 'pH',},
            val8: {name: '잔류염소', unit: 'mg/L',},
            val9: {name: '탁도', unit: 'NTU',},
            val10: {name: '수온', unit: '℃',},
        },
        buildingAlarmList: [],
        buildingPermitList: [],
        showSeoulmap: false,
        showLegend: $_WC.responsiveScale === 3 ? true : false,
        safetySggCenterMap: {},
        accidentSggCenterMap: {},
        waterSggCenterMap: {},
        seoulMapMenu: 'pm10',
        seoulRainfallMap: {},
        realtimeSummaryList: [],
        disWaterList: [],
        disasterTxt: [],
        safetyGroupList: [],
        accidentGroupList: [],
        selectedSafetyCate: 'all',
        safetyCodeList: [],
        uticCctvPopUrl: '',
    },
    getters: {
        getSafetyList(state) {
            return state.safetyList;
        },
        getSafetyTodayList(state) {
            return state.safetyTodayList;
        },
        getAccidentList(state) {
            return state.accidentList;
        },
        getWaterQualityList(state) {
            return state.waterQualityList;
        },
        getWaterLevelList(state) {
            return state.waterLevelList;
        },
        getUticCctvList(state) {
            return state.uticCctvList
        },
        getAccidentTypeCodeMap(state) {
            return state.accidentTypeCodeMap;
        },
        getWaterHjdMeta(state) {
            return state.waterHjdMeta
        },
        getBuildingAlarmList(state) {
            return state.buildingAlarmList;
        },
        getBuildingPermitList(state) {
            return state.buildingPermitList;
        },
        getShowSeoulmap(state) {
            return state.showSeoulmap;
        },
        getShowLegend(state) {
            return state.showLegend;
        },
        getSafetySggCenterMap(state) {
            return state.safetySggCenterMap;
        },
        getAccidentSggCenterMap(state) {
            return state.accidentSggCenterMap;
        },
        getWaterSggCenterMap(state) {
            return state.waterSggCenterMap;
        },
        getSeoulMapMenu(state) {
            return state.seoulMapMenu;
        },
        getSeoulRainfallMap(state) {
            return state.seoulRainfallMap;
        },
        getRealtimeSummaryList(state) {
            return state.realtimeSummaryList;
        },
        getDisWaterList(state) {
            return state.disWaterList;
        },
        getDisasterTxt(state) {
            return state.disasterTxt;
        },
        getSelectedSafetyCate(state) {
            return state.selectedSafetyCate;
        },
        getSafetyCodeList(state) {
            return state.safetyCodeList;
        },
        getUticCctvPopUrl(state) {
            return state.uticCctvPopUrl;
        },
    },
    mutations: {
        SAFETY_LIST(state, safetyList) {
            state.safetyList = safetyList;
        },
        SAFETY_TODAY_LIST(state, safetyTodayList) {
            state.safetyTodayList = safetyTodayList;
        },
        ACCIDENT_LIST(state, accidentList) {
            state.accidentList = accidentList;
        },
        WATER_QUALITY_LIST(state, waterQualityList) {
            state.waterQualityList = waterQualityList;
        },
        WATER_LEVEL_LIST(state, waterLevelList) {
            state.waterLevelList = waterLevelList;
        },
        UTIC_CCTV_LIST(state, uticCctvList) {
            state.uticCctvList = uticCctvList;
        },
        BUILDING_ALARM_LIST(state, buildingAlarmList) {
            state.buildingAlarmList = buildingAlarmList;
        },
        BUILDING_PERMIT_LIST(state, buildingPermitList) {
            state.buildingPermitList = buildingPermitList;
        },
        SHOW_SEOULMAP(state, showSeoulmap) {
            state.showSeoulmap = showSeoulmap;
        },
        SHOW_LEGEND(state, showLegend) {
            state.showLegend = showLegend;
        },
        SAFETY_SGG_CENTER_MAP(state, safetySggCenterMap) {
            state.safetySggCenterMap = safetySggCenterMap;
        },
        ACCIDENT_SGG_CENTER_MAP(state, accidentSggCenterMap) {
            state.accidentSggCenterMap = accidentSggCenterMap;
        },
        WATER_SGG_CENTER_MAP(state, waterSggCenterMap) {
            state.waterSggCenterMap = waterSggCenterMap;
        },
        SEOUL_MAP_MENU(state, seoulMapMenu) {
            state.seoulMapMenu = seoulMapMenu;
        },
        SEOUL_RAINFALL_MAP(state, seoulRainfallMap) {
            state.seoulRainfallMap = seoulRainfallMap;
        },
        REALTIME_SUMMARY_LIST(state, realtimeSummaryList) {
            state.realtimeSummaryList = realtimeSummaryList;
        },
        DIS_WATER_LIST(state, disWaterList) {
            state.disWaterList = disWaterList;
        },
        DISASTER_TXT(state, disasterTxt) {
            state.disasterTxt = disasterTxt;
        },
        SAFETY_GROUP_LIST(state, safetyGroupList) {
            state.safetyGroupList = safetyGroupList;
        },
        ACCIDENT_GROUP_LIST(state, accidentGroupList) {
            state.accidentGroupList = accidentGroupList;
        },
        SELECTED_SAFETY_CATE(state, selectedSafetyCate) {
                state.selectedSafetyCate = selectedSafetyCate;
        },
        SAFETY_CODE_LIST(state, safetyCodeList) {
            state.safetyCodeList = safetyCodeList;
        },
        UTIC_CCTV_POP_URL(state, uticCctvPopUrl) {
            state.uticCctvPopUrl = uticCctvPopUrl;
        },
    },
    actions : {
        // 재난안전 목록
        FETCH_SAFETY_LIST({commit}, q) {
            if(typeof q === $_WC.UNDEF) {
                q = 'stateMode=1&intervalDay=1'
            }
            if(process.env.NODE_ENV === 'local' || process.env.NODE_ENV === 'development') {
                q = 'stateMode=9&intervalDay=1200&searchFromDate=20210830000000&searchToDate=20210830235959';
            }

            return realtimeApi.fetchSafetyList(q)
                .then(res => {
                    // 재난, 화재의 경우 마커를 위에 표시하기 위해 sorting
                    let list = res.data.data;
                    list.sort((pre, cur) => {
                        return pre.safetyCategoryCd > cur.safetyCategoryCd ? -1 : pre.safetyCategoryCd < cur.safetyCategoryCd ? 1 : 0;
                    });
                    commit("SAFETY_LIST", res.data.data);
                });
        },

        FETCH_SAFETY_TODAY_LIST({commit}) {
            let now = new Date();
            now.setDate(now.getDate() - 0);
            let nowStr = now.format('yyyyMMdd');
            let q = 'stateMode=9&intervalDay=1&searchFromDate=' + nowStr + '000000&searchToDate=' + nowStr + '235959';

            if(process.env.NODE_ENV === 'local' || process.env.NODE_ENV === 'development') {
                q = 'stateMode=9&intervalDay=999&searchFromDate=20210830000000&searchToDate=20210830235959';
            }

            return realtimeApi.fetchSafetyList(q)
                .then(res => {
                    commit("SAFETY_TODAY_LIST", res.data.data);
                });
        },

        FETCH_SAFETY_CODE_LIST({commit}) {
            return commonApi.fetchCodeListByCodeGroup($_CD.SAFETY_CATE_CODE)
                .then(res => {
                    commit('SAFETY_CODE_LIST', res.data.data);
                });
        },

        SET_SELECTED_SAFETY_CATE({commit}, selectedSafetyCate) {
            commit('SELECTED_SAFETY_CATE', selectedSafetyCate);
        },

        // 돌발 상황 목록
        FETCH_ACCIDENT_LIST({commit}, q) {
            return commonApi.fetchRepoDataList($_DKD.ACCIDENT, q)
                .then(res => {
                    let accidentList = [];
                    let accidentSggCenterMap = {};

                    for(let guNm in $_ADM.GU_CENTER_MAP) {
                        if(typeof accidentSggCenterMap[guNm] === $_TYPE.UNDEF) {
                            accidentSggCenterMap[guNm] = {count: 0};
                        }
                        res.data.data.forEach((d)=>{
                            if(guNm === '강남구' && d.val4.indexOf('강남구') > -1) {
                                accidentList.push(d);
                            }
                            if(d.val4.indexOf(guNm) > -1){
                                accidentSggCenterMap[guNm].count++;
                            }
                        });
                    }
                    commit('ACCIDENT_SGG_CENTER_MAP', accidentSggCenterMap);
                    commit("ACCIDENT_LIST", accidentList);
                });
        },
        FETCH_WATER_QUALITY_LIST({commit}) {
            return commonApi.fetchMaxBasdtValDataList($_DKD.WATER_QUALITY)
                .then(res => {
                    let list = res.data.data;
                    for(let i in list) {
                        if(list[i].val4 == '개포3동') {
                            list[i].val2 = '1123074';
                        }
                    }
                    commit("WATER_QUALITY_LIST", gripUtil.toReplaceList(list, 'val4', '일원2동', '개포3동'));
                });
        },
        FETCH_WATER_LEVEL_LIST({commit}, q) {
            // 최신기준일로 하면 수위계 하나만 나옴
            let now = new Date();
            now.setDate(now.getDate() - 0);
            let nowStr = now.format('yyyyMMdd');
            q = 'searchFromDate=' + nowStr + '000000&searchToDate=' + nowStr + '235959&where=val4::101';
            return commonApi.fetchRepoDataList($_DKD.WATER_LEVEL, q)
                .then(res => {
                    let list = [];
                    let map = gripUtil.toMap(res.data.data, 'val1');
                    for(let k in map) {
                        list.push(map[k][0]);
                    }
                    commit("WATER_LEVEL_LIST", list);
                });
        },
        FETCH_UTIC_CCTV_LIST({commit}) {
            let q = 'fromLttdVal=37.44314745862556&fromLgtdVal=127.02755336174407&toLttdVal=37.546164125567536&toLgtdVal=127.11411910860451';
            return commonApi.fetchRepoDataList($_DKD.UTIC_CCTV, q)
                .then((res)=>{
                    commit("UTIC_CCTV_LIST", res.data.data);
                });
        },
        FETCH_BUILDING_ALARM_LIST({commit}) {
            let q = 'where=val11::1';
            commonApi.fetchRepoDataList($_DKD.BUILDING_ALARM, q)
                .then((res)=>{
                    commit('BUILDING_ALARM_LIST', res.data.data);
                });
        },
        FETCH_BUILDING_PERMIT_LIST({commit}) {
            commonApi.fetchRepoDataList($_DKD.BUILDING_PERMIT)
                .then((res)=>{
                    commit('BUILDING_PERMIT_LIST', res.data.data);
                });
        },
        SET_SHOW_SEOULMAP({commit}, showSeoulmap) {
            commit('SHOW_SEOULMAP', showSeoulmap);
        },
        SET_SHOW_LEGEND({commit}, showLegend) {
            commit('SHOW_LEGEND', showLegend);
        },
        FETCH_SAFETY_SGG_CENTER_LIST({commit}) {
            commonApi.fetchRepoDataList($_DKD.SAFETY_SGG_CENTER)
                .then((res)=>{
                    let safetySggCenterMap = {};
                    res.data.data.forEach((d)=>{
                        let key = d.val4;
                        if(typeof safetySggCenterMap[key] === $_TYPE.UNDEF) {
                            safetySggCenterMap[key] = {count: 0};
                        }
                        safetySggCenterMap[key].count++;
                    });
                    commit('SAFETY_SGG_CENTER_MAP', safetySggCenterMap);
                });
        },
        FETCH_WATER_SGG_QUALITY_LIST({commit}) {
            commonApi.fetchMaxBasdtValDataList($_DKD.WATER_SGG_QUALITY)
                .then((res)=>{
                    let waterSggCenterMap = {};
                    res.data.data.forEach((d) => {
                        let key = d.val1;
                        if(typeof waterSggCenterMap[key] === $_TYPE.UNDEF) {
                            waterSggCenterMap[key] = {
                                cnt: 0,
                                val7: 0,
                                val8: 0,
                                val9: 0,
                                val10: 0,
                            };
                        }
                        waterSggCenterMap[key].val7 += Number(d.val5);
                        waterSggCenterMap[key].val8 += Number(d.val6);
                        waterSggCenterMap[key].val9 += Number(d.val7);
                        waterSggCenterMap[key].val10 += Number(d.val8);
                        waterSggCenterMap[key].cnt++;
                    });
                    for(let key in waterSggCenterMap) {
                        waterSggCenterMap[key].val7 = waterSggCenterMap[key].val7 / waterSggCenterMap[key].cnt;
                        waterSggCenterMap[key].val8 = waterSggCenterMap[key].val8 / waterSggCenterMap[key].cnt;
                        waterSggCenterMap[key].val9 = waterSggCenterMap[key].val9 / waterSggCenterMap[key].cnt;
                        waterSggCenterMap[key].val10 = waterSggCenterMap[key].val10 / waterSggCenterMap[key].cnt;
                    }
                    commit('WATER_SGG_CENTER_MAP', waterSggCenterMap);
                });
        },
        SET_SEOUL_MAP_MENU({commit}, seoulMapMenu) {
            commit("SEOUL_MAP_MENU", seoulMapMenu);
        },
        FETCH_SEOUL_RAINFALL_LIST({commit}) {
            let today = new Date();
            let yesterDay = new Date(today - (3600000 * 24 * 1)).format('yyyyMMdd')+'0000';
            let nowDate = today.format('yyyyMMdd')+'0000';

            let q = 'searchFromDate=' + yesterDay;
            q += 'orderBy=basdt_val::desc';

            commonApi.fetchRepoDataList($_DKD.RAINFALL, q)
                .then(function(res) {

                    let list = [];
                    const seoulRainfallMap = {};
                    if(res.data.data.length > 0) {

                        let maxTime = res.data.data[0].basdtVal;
                        let maxTimeString = maxTime.substring(0,4)+ "/"
                            + maxTime.substring(4,6)
                            + "/" + maxTime.substring(6,8)
                            + " " + maxTime.substring(8,10)
                            + ":" + maxTime.substring(10,12);

                        let maxDate = new Date(maxTimeString);
                        //최신 데이터 기준 - 3시간 전 누적 데이터 가져오기
                        let beforeThreeHour = new Date(maxDate - (3600000 * 3)).format('yyyyMMddHHmm');
                        list = res.data.data.filter((data)=>{
                            return Number(data.basdtVal) >= Number(beforeThreeHour);
                        });

                        let dataMap = gripUtil.toMap(list, 'val4');

                        for(let key in dataMap) {
                            let guMap = gripUtil.toMap(dataMap[key], 'val2');
                            let dongObj = {};
                            let dongMaxObj = {};

                            for(let dongNm in guMap) {
                                guMap[dongNm].forEach((dongInfo)=>{
                                    if(typeof dongObj[dongNm] === $_TYPE.UNDEF) {
                                        dongObj[dongNm] = {
                                            centerCode : dongInfo.val1,
                                            centerNm : dongInfo.val2,
                                            sggNm : dongInfo.val4,
                                            dongSum : 0,
                                            threeHourSum : 0,
                                            basdtVal : maxTimeString,
                                        }
                                    }
                                    dongObj[dongNm].threeHourSum += Number(dongInfo.val5);
                                });
                            }
                            let dongList = gripUtil.toList(dongObj);
                            //3시간 누적 값이 가장 높은 측정소
                            if(dongList.length > 0) {
                                dongList.sort((cur, pre)=>{
                                    return Number(pre.threeHourSum) > Number(cur.threeHourSum) ? 1 : Number(pre.threeHourSum) < Number(cur.threeHourSum) ? -1 : 0;
                                })
                                dongMaxObj = dongList[0];
                            }
                            seoulRainfallMap[key] = dongMaxObj;
                        }
                    }
                    commit("SEOUL_RAINFALL_MAP", seoulRainfallMap);
                });
        },
        FETCH_REALTIME_SUMMARY_LIST({commit}) {
            commonApi.fetchRepoDataList($_DKD.REALTIME_SUMMARY)
                .then(res=>{
                    commit('REALTIME_SUMMARY_LIST', res.data.data);
                });
        },

        // 하천수위 추가
        FETCH_DIS_WATER_LIST({commit}, q) {
            commonApi.fetchRepoDataList($_DKD.DISASTER_WATER_LEVEL, q)
                .then(res =>{
                    //1869 - val1:code/ val2:명 / val6: 현재수위 / val7: 제방고 / val8: 계획홍수위
                    //1870 - val1:code/ val2:명 / val5: 현재수위 / val11: 제방고(5단계 수위) / val9: 계획홍수위(3단계 수위)
                    //1869 기준으로 1870 재구성
                    let disWaterList = res.data.data;
                    let disWater = [];
                    if(typeof disWaterList !== 'undefined') {
                        disWaterList.forEach(function(d) {
                            let disWaterTmp = {
                                amnDataSqno: d.amnDataSqno,
                                basdtVal: d.basdtVal,
                                dataKdSqno: d.dataKdSqno,
                                lgtdVal: d.lgtdVal,
                                lttdVal: d.lttdVal,
                                rflbDataSqno: d.rflbDataSqno,
                                updt: d.updt,
                                val1: d.val1,
                                val2: d.val2,
                                val6: d.val5,
                                val7: d.val11,
                                val8: d.val9
                            }
                            disWater.push(disWaterTmp);
                        });
                    }
                    commit('DIS_WATER_LIST', disWater);
                });
        },

        // 행정안전부_재난문자
        FETCH_DISASTER_TXT({commit}) {
            // 금일 재난문자만 보여줌.
            let today = new Date();
            // let yesterDay = new Date(today - (3600000 * 24 * 1));
            let searchFromDate = today.format('yyyyMMdd')+'000000';
            // console.log('searchFromDate', searchFromDate);
            let q = 'searchFromDate=' + searchFromDate + '&orderBy=basdtVal::desc';

            // 로컬의 경우 검색범위 변경
            if(process.env.NODE_ENV === 'local') {
                searchFromDate = '20230126081000';
                q = 'searchFromDate=' + searchFromDate + '&orderBy=basdtVal::desc';
            }

            // commonApi.fetchRepoDataList($_DKD.DISASTER_TXT, q)
            //     .then(res => {
            //         let list = res.data.data;
            //         // 실종신고 제외
            //         list = list.filter(d => {
            //             if(d.val2.includes('서울특별시 전체')) {
            //                 return !d.val4.includes('찾습니다');
            //             } else {
            //                 return !d.val4.includes('찾습니다') && !d.val2.includes('충청남도');
            //             }
            //         });
            //         // console.log('list', list);
            //         commit('DISASTER_TXT', list);
            //     });
            commonApi.fetchRepoDataList($_DKD.DISASTER_TEXT, q)
                .then(res => {
                    let list = res.data.data;
                    // console.log('list', list);
                    // 실종신고 제외
                    list = list.filter(d => {
                        return !d.val3.includes('찾습니다');
                    });
                    list = list.sort((pre, cur) => {
                        return Number(pre.basdtVal) - Number(cur.basdtVal);
                    });
                    commit('DISASTER_TXT', list);
                });
        },

        FETCH_SAFETY_GROUP_LIST({commit}) {
            let searchDay = new Date();
            searchDay.setDate(searchDay.getDate() - 14);
            let searchFromDate = searchDay.format('yyyyMMdd')+'000000';
            if(process.env.NODE_ENV === 'local' || process.env.NODE_ENV === 'development') {
                searchFromDate = '20210701000000';
            }
            let q = 'searchFromDate=' + searchFromDate;
            // stateMode == 9 쿼리로 맞춤
            q += '&whereNotLike=val13::' + encodeURIComponent('오인처리');
            q += '&whereNotLike=val5::' + encodeURIComponent('119시험방송');
            q += '&whereNotLike=val5::' + encodeURIComponent('소방시설오작동');
            q += '&groupFieldList=basdtVal&groupFieldList=val4&substrStart=1&substrEnd=8&orderColnms=groupVal1&sortDirs=desc';
            // console.log( q );
            commonApi.fetchListGroupCountByColArray($_DKD.SAFETY, q)
                .then(res=>{
                    let list = [];
                    const map = {};
                    res.data.data.forEach(d => {
                        let key = d.groupVal1;
                        let type = d.groupVal2;
                        if(typeof map[key] === 'undefined'){
                            map[key] = {
                                'basdtVal': key,
                                '0': 0,     // 재난
                                '1': 0,     // 화재
                                '2': 0,     // 구조
                                '3': 0,     // 구급
                            };
                            list.push(map[key]);
                        }
                        if(typeof map[key][type] !== 'undefined'){
                            map[key][type] = d.dataCnt;
                        }
                    });
                    // console.log(list);
                    commit('SAFETY_GROUP_LIST', list);
                });
        },
        FETCH_ACCIDENT_GROUP_LIST({commit}) {
            let searchDay = new Date();
            searchDay.setDate(searchDay.getDate() - 14);
            let searchFromDate = searchDay.format('yyyyMMdd')+'0000';
            if(process.env.NODE_ENV === 'local' || process.env.NODE_ENV === 'development') {
                searchFromDate = '202207010000';
            }
            let q = 'searchFromDate=' + searchFromDate;
            q += '&whereLike=val4::' + encodeURIComponent('%강남구%');
            q += '&groupFieldList=basdtVal&groupFieldList=val2&substrStart=1&substrEnd=8&orderColnms=groupVal1&sortDirs=desc';
            // console.log( q );
            commonApi.fetchListGroupCountByColArray($_DKD.ACCIDENT, q)
                .then(res=>{
                    let list = [];
                    const map = {};
                    res.data.data.forEach(d => {
                        let key = d.groupVal1;
                        let type = d.groupVal2;
                        if(typeof map[key] === 'undefined'){
                            map[key] = {
                                'basdtVal': key,
                                '1': 0,     // 사고
                                '2': 0,     // 공사
                                '3': 0,     // 행사
                                '5': 0,     // 통제
                            };
                            list.push(map[key]);
                        }
                        if(typeof map[key][type] !== 'undefined'){
                            map[key][type] = d.dataCnt;
                        }
                    });
                    // console.log(list);
                    commit('ACCIDENT_GROUP_LIST', list);
                });
        },
        FETCH_UTIC_CCTV_POP_URL({commit}) {
            return commonApi.fetchRepoDataList($_DKD.UTIC_CCTV_POPUP_URL)
                .then((res)=>{
                    let url = '';
                    res.data.data.forEach(d => {
                        url = d.val2;
                    });
                    commit("UTIC_CCTV_POP_URL", url);
                });
        },
    }
};
